/* global axios */
import ApiClient from './ApiClient';

class DealStageAPI extends ApiClient {
  constructor() {
    super('deal_stages', { accountScoped: true });
  }

  reorder(orderedIds) {
    return axios.patch(`${this.url}/reorder`, { ordered_ids: orderedIds });
  }
}

export default new DealStageAPI();
